import { DataTableColumnHeader } from "@components/ui/data-table/DataTableColumnHeader";
import { createColumn } from "@/lib/table/columnFactory";
import { TicketTitleCell } from "./cells/TicketCells";
import type { Ticket, TicketColumnSettings } from "./types";

export const titleColumnFactory = (settings: TicketColumnSettings) =>
  createColumn<Ticket>({
    id: "title",
    accessorKey: "title",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Titre" />,
    cell: ({ row }) => <TicketTitleCell ticket={row.original} cellText={settings.cellText} />,
    size: settings.colWidth.name,
  });
